<template>
  <GradientBorder class="min-w-40">
    <div
      class="flex px-4 py-2 gap-x-2 rounded-t-2xl bg-black/30 rounded-b-none m-[2px] justify-between border-b border-neutral-500 text-white font-semibold"
    >
      {{ legend.name }}
      <span>{{ legend.unit }}</span>
    </div>

    <div class="flex flex-col gap-2.5 text-white text-sm pl-4 py-5 pr-8">
      <div v-for="(grade, idx) in legend.grades" :key="idx" class="flex flex-row gap-3 items-center">
        <div class="w-6 h-6 rounded-md" :style="{ 'background-color': grade.color }" />
        <div v-if="idx === 0" class="flex">&ge; {{ formatValue(grade.min) }}</div>
        <div v-else class="flex">{{ formatValue(grade.min) }} &ndash; {{ formatValue(grade.max) }}</div>
      </div>
    </div>
  </GradientBorder>
</template>

<script lang="ts" setup>
import type { DrillLegend } from '~/entities/drillHole'

defineProps({
  legend: {
    type: Object as PropType<DrillLegend>,
    required: true,
  },
})

function formatValue(value = 0) {
  return Number(value).toFixed(1)
}
</script>
